import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ESevaiPro.css';

export default function App() {
  // --- STATE FOR REGISTRATION FORM ---
  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    whatsappNumber: '',
    district: '',
    taluk: '',
    centreName: '',
    experience: '1-3 Years',
    categories: [],
    customServices: '',
    expectedCharge: '',
    dailyCapacity: '3-5 Applications',
    paymentPref: 'UPI',
    notes: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // --- STATE FOR ADMIN AUTHENTICATION & DASHBOARD ---
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [adminPasswordInput, setAdminPasswordInput] = useState('');
  const [adminAuthError, setAdminAuthError] = useState('');
  
  const [leadList, setLeadList] = useState([]);
  const [adminFilter, setAdminFilter] = useState('');
  const [isLoadingLeads, setIsLoadingLeads] = useState(false);

  // Handle Form Input Changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryCheckbox = (category) => {
    setFormData((prev) => {
      const exists = prev.categories.includes(category);
      if (exists) {
        return { ...prev, categories: prev.categories.filter((c) => c !== category) };
      } else {
        return { ...prev, categories: [...prev.categories, category] };
      }
    });
  };

  // --- 1. FORM SUBMISSION HANDLER ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('/api.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setIsSubmitting(false);
        setIsSubmitted(true);
      } else {
        alert('Error: ' + result.message);
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('Server-ல் இணைப்பதில் சிக்கல் உள்ளது. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.');
      setIsSubmitting(false);
    }
  };

  // --- 2. ADMIN LOGIN VERIFICATION ---
  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setAdminAuthError('');

    try {
      const response = await fetch('/api.php?action=admin_login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: adminPasswordInput }),
      });

      const result = await response.json();

      if (result.status === 'success') {
        setIsAdminAuthenticated(true);
        fetchAdminLeads();
      } else {
        setAdminAuthError('தவறான கடவுச்சொல்! (Invalid Password)');
      }
    } catch (error) {
      console.error('Auth error:', error);
      setAdminAuthError('Server error. Please try again.');
    }
  };

  // --- 3. FETCH LEADS FROM MYSQL ---
  const fetchAdminLeads = async () => {
    setIsLoadingLeads(true);
    try {
      const response = await fetch('/api.php');
      const result = await response.json();
      if (result.status === 'success') {
        setLeadList(result.data);
      }
    } catch (error) {
      console.error('Error fetching leads:', error);
    } finally {
      setIsLoadingLeads(false);
    }
  };

  const handleCloseAdminModal = () => {
    setShowAdminModal(false);
    setIsAdminAuthenticated(false);
    setAdminPasswordInput('');
    setAdminAuthError('');
  };

  const scrollToRegister = () => {
    document.getElementById('register-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToHowItWorks = () => {
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="bg-light text-dark min-vh-100 d-flex flex-column position-relative">
      
      {/* HEADER / NAVIGATION */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top border-bottom py-2 shadow-sm">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center gap-2" href="#root">
            <span className="bg-teal text-white fw-bold px-2 py-1 rounded bg-dark">
              <i className="bi bi-shield-check text-warning me-1"></i>E-Sevai
            </span>
            <span className="fw-bold text-teal" style={{ color: '#0d9488' }}>PRO</span>
            <span className="badge bg-secondary text-light ms-1" style={{ fontSize: '0.65rem' }}>EXPERT PARTNER</span>
          </a>
          
          <div className="d-flex align-items-center gap-2 ms-auto">
            <button className="btn btn-sm btn-outline-secondary d-none d-md-inline-block" onClick={() => setShowAdminModal(true)}>
              <i className="bi bi-lock-fill me-1"></i> Admin Login
            </button>
            <button className="btn btn-primary-custom btn-sm px-3" onClick={scrollToRegister}>
              Partner Join <i className="bi bi-arrow-right ms-1"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* SECTION 1 — HERO */}
      <header className="hero-wrapper">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6">
              <div className="zero-fee-badge mb-3">
                <i className="bi bi-patch-check-fill text-emerald me-1"></i> No Joining Fee • 100% Free Partner Registration
              </div>
              <h1 className="display-5 fw-extrabold text-dark mb-3 lh-tight">
                உங்கள் திறமையை <br />
                <span style={{ color: '#0d9488' }}>வருமானமாக மாற்றுங்கள்</span>
              </h1>
              <p className="lead text-secondary mb-4 fs-6">
                E-Sevai Pro Expert Partner ஆக இணைந்து, நீங்கள் நன்றாக அறிந்த சேவைகளுக்கான வேலைகளை மற்ற E-Sevai மையங்களிலிருந்து பெற்று சம்பாதிக்கலாம்.
              </p>
              
              <div className="p-3 bg-white border rounded-3 shadow-sm mb-4">
                <div className="row text-center g-2">
                  <div className="col-4 border-end">
                    <span className="d-block text-muted small">Registration</span>
                    <strong className="text-success"><i className="bi bi-x-circle-fill text-danger me-1 d-none d-sm-inline"></i>இல்லை (₹0)</strong>
                  </div>
                  <div className="col-4 border-end">
                    <span className="d-block text-muted small">Joining Fee</span>
                    <strong className="text-success"><i className="bi bi-x-circle-fill text-danger me-1 d-none d-sm-inline"></i>இல்லை (₹0)</strong>
                  </div>
                  <div className="col-4">
                    <span className="d-block text-muted small">Activation Fee</span>
                    <strong className="text-success"><i className="bi bi-x-circle-fill text-danger me-1 d-none d-sm-inline"></i>இல்லை (₹0)</strong>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-column flex-sm-row gap-3">
                <button className="btn btn-primary-custom btn-lg" onClick={scrollToRegister}>
                  Expert Partner ஆக Register செய்யுங்கள்
                </button>
                <button className="btn btn-outline-custom btn-lg" onClick={scrollToHowItWorks}>
                  எப்படி வேலை செய்கிறது?
                </button>
              </div>
            </div>

            {/* VISUAL MOCKUP SECTION */}
            <div className="col-lg-6">
              <div className="mockup-window">
                <div className="mockup-header">
                  <div className="dot bg-danger"></div>
                  <div className="dot bg-warning"></div>
                  <div className="dot bg-success"></div>
                  <span className="small text-muted ms-2 font-monospace">expert.esevaipro.in/dashboard</span>
                </div>
                <div className="p-4 bg-light">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <small className="text-muted d-block">Partner Dashboard</small>
                      <h6 className="mb-0 fw-bold">வணக்கம், Expert Partner! 👋</h6>
                    </div>
                    <span className="badge bg-success-subtle text-success border border-success px-2 py-1">
                      <i className="bi bi-record-fill me-1 animate-pulse"></i> Receiving Requests
                    </span>
                  </div>

                  <div className="card border-0 shadow-sm mb-3">
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <span className="badge bg-primary-subtle text-primary fw-medium">New Request Received</span>
                        <small className="text-muted">2 mins ago</small>
                      </div>
                      <h6 className="fw-bold mb-1">Patta Transfer / Income Certificate Application</h6>
                      <p className="small text-muted mb-2">Request Centre: Annai E-Sevai, Madurai</p>
                      <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded">
                        <span className="small font-monospace">Your Fixed Price: <strong>₹150</strong></span>
                        <span className="badge bg-dark text-white">Status: Pending Completion</span>
                      </div>
                    </div>
                  </div>

                  <div className="row g-2">
                    <div className="col-6">
                      <div className="p-3 bg-white rounded border">
                        <small className="text-muted d-block">Today's Earnings</small>
                        <span className="fs-5 fw-bold text-teal" style={{ color: '#0d9488' }}>₹750.00</span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="p-3 bg-white rounded border">
                        <small className="text-muted d-block">Withdrawal Status</small>
                        <span className="fs-6 fw-semibold text-success"><i className="bi bi-check-circle-fill me-1"></i> Ready (Bank/UPI)</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* SECTION 2 — CORE VALUE PROPOSITION */}
      <section className="py-5 bg-white border-bottom">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto mb-5">
            <span className="badge bg-teal-subtle text-teal fw-bold px-3 py-2 rounded-pill mb-2" style={{ backgroundColor: '#e6fffa', color: '#0d9488' }}>
              ஏன் E-Sevai Pro?
            </span>
            <h2 className="fw-bold text-dark">
              நீங்கள் Expert என்றால், உங்களுக்கான வேலைகள் இப்போது உங்கள் அருகிலேயே இல்லை — E-Sevai Pro மூலம் மற்ற மையங்களிலிருந்தும் வரலாம்.
            </h2>
          </div>

          <div className="row g-4">
            <div className="col-md-6 col-lg-4">
              <div className="saas-card p-4">
                <div className="icon-box icon-teal">
                  <i className="bi bi-sliders"></i>
                </div>
                <h5 className="fw-bold mb-2">விருப்பமான சேவைகள்</h5>
                <p className="text-secondary small mb-0">
                  உங்களுக்கு நன்றாகத் தெரிந்த மற்றும் விரைவாக செய்யக்கூடிய சேவைகளை மட்டும் தேர்வு செய்து கொள்ள முழு சுதந்திரம் உண்டு.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="saas-card p-4">
                <div className="icon-box icon-blue">
                  <i className="bi bi-box-arrow-in-down"></i>
                </div>
                <h5 className="fw-bold mb-2">வரம்பற்ற Requests</h5>
                <p className="text-secondary small mb-0">
                  மற்ற E-Sevai centres-க்கு குறிப்பிட்ட சேவை தேவைப்பட்டால், அவர்கள் நேரடி Application Request-ஐ உங்களிடம் அனுப்புவார்கள்.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4">
              <div className="saas-card p-4">
                <div className="icon-box icon-green">
                  <i className="bi bi-currency-rupee"></i>
                </div>
                <h5 className="fw-bold mb-2">உங்கள் கட்டணம்</h5>
                <p className="text-secondary small mb-0">
                  அந்த குறிப்பிட்ட service-க்கு நீங்கள் உங்கள் சொந்த Service Charge-ஐ நீங்களே நிர்ணயிக்கலாம். கட்டணக் கட்டுப்பாடு இல்லை.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 — "NO FEES" SECTION */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="p-4 p-md-5 rounded-4 bg-white border shadow-sm text-center">
            <span className="badge bg-danger-subtle text-danger fw-bold px-3 py-1 mb-2">100% Free Joining</span>
            <h2 className="fw-bold mb-2">இணைய எந்த கட்டணமும் இல்லை!</h2>
            <p className="text-muted mb-4">நீங்கள் Expert Partner ஆக register செய்வதற்காக எந்த கட்டணமும் செலுத்த வேண்டியதில்லை.</p>

            <div className="row g-3 justify-content-center mb-4">
              {[
                "Registration Fee இல்லை",
                "Joining Fee இல்லை",
                "Activation Fee இல்லை",
                "Hidden Charges இல்லை"
              ].map((feeText, idx) => (
                <div key={idx} className="col-6 col-md-3">
                  <div className="p-3 bg-light rounded-3 border d-flex align-items-center justify-content-center gap-2">
                    <i className="bi bi-check-circle-fill text-success fs-5"></i>
                    <span className="fw-bold text-dark small">{feeText}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-3 bg-teal-subtle rounded-3 d-inline-block" style={{ backgroundColor: '#f0fdf4' }}>
              <p className="mb-0 text-success fw-medium small">
                <i className="bi bi-shield-check me-2"></i>
                வெளிப்படையான சூழல். நீங்கள் செய்யும் வேலைக்கான வருமானம் உங்களுக்கு முழுமையாக வந்து சேரும்.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — ADD YOUR EXPERT SERVICE */}
      <section className="py-5 bg-white border-top border-bottom">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6">
              <span className="badge bg-primary-subtle text-primary fw-bold mb-2">Custom Service Addition</span>
              <h2 className="fw-bold mb-3">உங்கள் Expert Service இங்கே இல்லையா?</h2>
              <p className="text-secondary">
                நீங்கள் செய்யக்கூடிய ஒரு service E-Sevai Pro-ல் தற்போது இல்லையென்றாலும், அந்த service-ஐ platform-ல் சேர்க்க request செய்யலாம்.
              </p>
              <p className="text-secondary small">
                தேவையான verification/approval process முடிந்த பிறகு, அந்த service-ஐ platform-ல் வழங்குவதற்கான வாய்ப்பு கிடைக்கும்.
              </p>
            </div>
            
            <div className="col-lg-6">
              <div className="p-4 bg-light rounded-4 border">
                <h6 className="fw-bold mb-3">Service Addition Flow:</h6>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex align-items-center gap-3 p-2 bg-white rounded border">
                    <span className="badge bg-dark">1</span>
                    <span className="small fw-semibold">Your Expertise</span>
                  </div>
                  <div className="text-center text-muted"><i className="bi bi-arrow-down"></i></div>
                  <div className="d-flex align-items-center gap-3 p-2 bg-white rounded border">
                    <span className="badge bg-dark">2</span>
                    <span className="small fw-semibold">Add Service Request</span>
                  </div>
                  <div className="text-center text-muted"><i className="bi bi-arrow-down"></i></div>
                  <div className="d-flex align-items-center gap-3 p-2 bg-white rounded border">
                    <span className="badge bg-dark">3</span>
                    <span className="small fw-semibold">Receive Requests & Complete Work</span>
                  </div>
                  <div className="text-center text-muted"><i className="bi bi-arrow-down"></i></div>
                  <div className="d-flex align-items-center gap-3 p-2 bg-success text-white rounded">
                    <span className="badge bg-white text-dark">4</span>
                    <span className="small fw-semibold">Earn Payment</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 — YOU SET YOUR OWN SERVICE PRICE */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center max-w-2xl mx-auto mb-5">
            <h2 className="fw-bold">உங்கள் Service-க்கு உங்கள் கட்டணத்தை நீங்களே நிர்ணயிக்கலாம்</h2>
            <p className="text-secondary">ஒவ்வொரு service-க்கும் நீங்கள் ஏற்றுக்கொள்ளக்கூடிய service charge-ஐ நீங்களே நிர்ணயிக்கலாம்.</p>
          </div>

          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="card border-0 shadow-sm p-4">
                <h6 className="fw-bold text-muted mb-3 border-bottom pb-2">உதாரண கணக்கீடு:</h6>
                
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <span className="fw-bold d-block">Government Certificate Application</span>
                    <small className="text-muted">Customer Document Verification & Submission</small>
                  </div>
                  <span className="badge bg-success-subtle text-success fs-6 fw-bold">₹120 / Service</span>
                </div>

                <div className="p-3 bg-light rounded mb-3">
                  <div className="d-flex justify-content-between small text-muted mb-1">
                    <span>Incoming Request</span>
                    <span>Status</span>
                  </div>
                  <div className="d-flex justify-content-between fw-semibold">
                    <span>Request Received → Work Completed</span>
                    <span className="text-success">+ ₹120 Added</span>
                  </div>
                </div>

                <div className="alert alert-info py-2 mb-0 small">
                  <i className="bi bi-info-circle me-1"></i>
                  Note: உங்களுக்கான வருமானம் உங்கள் திறமை மற்றும் சேவை எண்ணிக்கையை பொறுத்தது.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — HOW IT WORKS */}
      <section id="how-it-works" className="py-5 bg-white border-top border-bottom">
        <div className="container">
          <div className="text-center mb-5">
            <span className="badge bg-primary-subtle text-primary fw-bold px-3 py-2 rounded-pill mb-2">எளிய வழிமுறை</span>
            <h2 className="fw-bold">எப்படி வேலை செய்கிறது?</h2>
          </div>

          <div className="row g-4">
            {[
              { step: '1', title: 'Register as Expert Partner', desc: 'இலவசமாக பதிவு செய்து உங்கள் விவரங்களை பூர்த்தி செய்யுங்கள்.' },
              { step: '2', title: 'Expert Services-ஐ தேர்வு செய்யுங்கள்', desc: 'உங்களுக்கு நன்றாகத் தெரிந்த சேவைகளை மட்டும் தேர்வு செய்யுங்கள்.' },
              { step: '3', title: 'Requests பெறுங்கள்', desc: 'மற்ற E-Sevai centres-லிருந்து நேரடியாக Service Requests வரும்.' },
              { step: '4', title: 'வேலையை Complete செய்யுங்கள்', desc: 'துல்லியமாக ஆன்லைன் விண்ணப்பங்களை பூர்த்தி செய்யுங்கள்.' },
              { step: '5', title: 'Payment பெறுங்கள்', desc: 'வேலை முடித்தவுடன் கணக்கில் பணம் நேரடியாக பெறலாம்.' }
            ].map((item, idx) => (
              <div key={idx} className="col-md-6 col-lg text-center">
                <div className="p-3 h-100 d-flex flex-column align-items-center">
                  <div className="step-number mb-3">{item.step}</div>
                  <h6 className="fw-bold mb-2">{item.title}</h6>
                  <p className="text-secondary small mb-0">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 7 — WHY EXPERT OPERATORS SHOULD JOIN */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">ஏன் நீங்கள் Expert Partner ஆக வேண்டும்?</h2>
          </div>

          <div className="row g-4">
            {[
              { title: "More Opportunities", desc: "மற்ற centres-லிருந்தும் service requests பெறும் வாய்ப்பு.", icon: "bi-graph-up-arrow" },
              { title: "Work From Your Expertise", desc: "உங்களுக்கு நன்றாக தெரிந்த services-ல் மட்டும் வேலை செய்யலாம்.", icon: "bi-patch-check" },
              { title: "Set Your Own Price", desc: "உங்கள் service charge-ஐ நீங்களே நிர்ணயிக்கலாம்.", icon: "bi-tags" },
              { title: "No Registration Fee", desc: "Expert Partner ஆக register செய்ய கட்டணம் இல்லை.", icon: "bi-wallet2" },
              { title: "Expand Your Services", desc: "உங்கள் expertise-ஐ platform மூலம் அதிகமான centres-க்கு கொண்டு செல்லலாம்.", icon: "bi-bounding-box-circles" },
              { title: "Transparent Earnings", desc: "உங்கள் requests, completed work மற்றும் earnings ஆகியவற்றை dashboard-ல் தெளிவாக பார்க்க முடியும்.", icon: "bi-pie-chart" }
            ].map((benefit, idx) => (
              <div key={idx} className="col-md-6 col-lg-4">
                <div className="saas-card p-4">
                  <i className={`bi ${benefit.icon} fs-3 text-teal mb-3 d-block`} style={{ color: '#0d9488' }}></i>
                  <h5 className="fw-bold mb-2">{benefit.title}</h5>
                  <p className="text-secondary small mb-0">{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 8 — PAYMENT / WITHDRAWAL */}
      <section className="py-5 bg-white border-top border-bottom">
        <div className="container">
          <div className="text-center max-w-2xl mx-auto mb-5">
            <h2 className="fw-bold">வேலை முடித்ததும் Payment பெறுவது எளிது</h2>
            <p className="text-secondary">உங்கள் earnings-ஐ பெறுவதற்கான payment process எளிமையாகவும் தெளிவாகவும் இருக்கும்.</p>
          </div>

          <div className="row g-4 justify-content-center mb-4">
            <div className="col-md-4">
              <div className="saas-card p-4 text-center">
                <i className="bi bi-bank fs-1 text-primary mb-2"></i>
                <h6 className="fw-bold">Bank Account</h6>
                <p className="small text-muted mb-0">நேரடி வங்கி கணக்கு மாற்றம் (Direct Bank Transfer)</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="saas-card p-4 text-center">
                <i className="bi bi-phone fs-1 text-success mb-2"></i>
                <h6 className="fw-bold">UPI Payments</h6>
                <p className="small text-muted mb-0">Google Pay, PhonePe, Paytm மூலம் உடனடியாக பெறலாம்</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="saas-card p-4 text-center">
                <i className="bi bi-qr-code-scan fs-1 text-dark mb-2"></i>
                <h6 className="fw-bold">UPI QR Code</h6>
                <p className="small text-muted mb-0">உங்கள் சொந்த QR Code setup செய்து கொள்ளும் வசதி</p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <span className="badge bg-dark text-white p-2 px-3 rounded-pill font-monospace">
              <i className="bi bi-shield-lock-fill text-warning me-2"></i>Clear • Simple • Transparent Payments
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 9 — WHAT SERVICES CAN YOU PROVIDE? */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">நீங்கள் வழங்கக்கூடிய சேவைகள்</h2>
            <p className="text-secondary">கீழ்கண்ட வகைகளில் உங்களுக்கு அனுபவம் இருந்தால் உடனடியாக இணையலாம்</p>
          </div>

          <div className="row g-3">
            {[
              { title: "Government Applications", icon: "bi-building-gear" },
              { title: "Certificate Applications", icon: "bi-file-earmark-medical" },
              { title: "Online Form Services", icon: "bi-laptop" },
              { title: "Document-related Services", icon: "bi-folder-check" },
              { title: "Registration Services", icon: "bi-card-checklist" },
              { title: "Other Digital Services", icon: "bi-grid-1x2" }
            ].map((srv, idx) => (
              <div key={idx} className="col-6 col-md-4 col-lg-2">
                <div className="saas-card p-3 text-center h-100 d-flex flex-column align-items-center justify-content-center">
                  <i className={`bi ${srv.icon} fs-2 text-teal mb-2`} style={{ color: '#0d9488' }}></i>
                  <span className="fw-semibold small text-dark">{srv.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 10 — REALISTIC EARNING EXAMPLE */}
      <section className="py-5 bg-white border-top border-bottom">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="calc-card p-4 p-md-5">
                <h4 className="fw-bold mb-3"><i className="bi bi-calculator me-2"></i>வருமான வாய்ப்பு கணக்கீடு (Example)</h4>
                <p className="text-light-50 small mb-4">
                  இது ஒரு உதாரண கணக்கீடு மட்டுமே. உங்கள் பணித்திறன் மற்றும் பெறப்படும் விண்ணப்பங்களைப் பொறுத்து மாறுபடும்.
                </p>

                <div className="row g-3 text-center align-items-center bg-dark p-3 rounded-3 border border-secondary mb-3">
                  <div className="col-md-4">
                    <span className="d-block text-muted small">ஒரு நாளில் Requests</span>
                    <strong className="fs-4 text-white">5 Applications</strong>
                  </div>
                  <div className="col-md-1 fs-4 text-teal">×</div>
                  <div className="col-md-3">
                    <span className="d-block text-muted small">Service Charge</span>
                    <strong className="fs-4 text-teal">₹100</strong>
                  </div>
                  <div className="col-md-1 fs-4 text-teal">=</div>
                  <div className="col-md-3">
                    <span className="d-block text-muted small">Daily Earnings</span>
                    <strong className="fs-3 text-emerald" style={{ color: '#2dd4bf' }}>₹500 / Day</strong>
                  </div>
                </div>

                <small className="text-secondary d-block">
                  *குறிப்பு: உறுதியான மாத வருமானம் என்று எந்த பொய் வாக்குறுதியும் அளிக்கப்படாது.
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 11 — TRUST & TRANSPARENCY */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">நம்பிக்கை & வெளிப்படைத்தன்மை</h2>
          </div>

          <div className="row g-4">
            {[
              { title: "Transparent Charges", desc: "மறைமுக கட்டணங்கள் ஏதுமின்றி வெளிப்படையான பணிச்சூழல்.", icon: "bi-eye" },
              { title: "Clear Request Details", desc: "விண்ணப்பத்தின் முழு விவரங்களும் உங்களுக்கு தெளிவுபடுத்தப்படும்.", icon: "bi-file-text" },
              { title: "Earnings Visibility", desc: "ஒவ்வொரு சேவைக்கும் கிடைக்கும் தொகை Dashboard-ல் உடனுக்குடன் அப்டேட் ஆகும்.", icon: "bi-display" },
              { title: "Secure Account", desc: "உங்கள் தரவுகள் மற்றும் வங்கி தகவல்கள் பாதுகாப்பாக பராமரிக்கப்படும்.", icon: "bi-shield-check" }
            ].map((trust, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div className="saas-card p-4 text-center">
                  <i className={`bi ${trust.icon} fs-2 text-teal mb-2`} style={{ color: '#0d9488' }}></i>
                  <h6 className="fw-bold mb-2">{trust.title}</h6>
                  <p className="text-secondary small mb-0">{trust.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 12 — FAQ */}
      <section className="py-5 bg-white border-top border-bottom">
        <div className="container">
          <div className="text-center max-w-2xl mx-auto mb-5">
            <h2 className="fw-bold">அடிக்கடி கேட்கப்படும் கேள்விகள் (FAQ)</h2>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="accordion" id="faqAccordion">
                {[
                  {
                    q: "Expert Partner ஆக register செய்ய கட்டணம் உள்ளதா?",
                    a: "இல்லை. Registration Fee, Joining Fee அல்லது Activation Fee என எந்த கட்டணமும் இல்லை."
                  },
                  {
                    q: "எனக்கு தெரிந்த service platform-ல் இல்லையென்றால்?",
                    a: "அந்த service-ஐ add செய்ய request செய்யலாம். தேவையான verification/approval முடிந்த பிறகு platform-ல் வழங்கும் வாய்ப்பு கிடைக்கும்."
                  },
                  {
                    q: "Service price-ஐ யார் நிர்ணயிப்பார்கள்?",
                    a: "Expert Partner தனது service charge-ஐ தானே நிர்ணயிக்கலாம்."
                  },
                  {
                    q: "மற்ற centres-லிருந்து வேலை கிடைக்குமா?",
                    a: "உங்களுக்கு தேவையான service requests கிடைக்கும் வாய்ப்பு உள்ளது. Requests availability தேவையும் platform activity-யும் பொறுத்தது."
                  },
                  {
                    q: "Payment எப்படி பெறுவது?",
                    a: "உங்கள் payment details/UPI போன்ற முறைகள் மூலம் earnings-ஐ நேரடியாக பெறலாம்."
                  },
                  {
                    q: "E-Sevai Pro-வின் மற்ற tools/features பயன்படுத்த முடியுமா?",
                    a: "ஆம். தேவையான additional tools/features subscription அல்லது applicable plan அடிப்படையில் கிடைக்கலாம்."
                  }
                ].map((faq, idx) => (
                  <div key={idx} className="accordion-item">
                    <h2 className="accordion-header" id={`heading${idx}`}>
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${idx}`}
                        aria-expanded="false"
                        aria-controls={`collapse${idx}`}
                      >
                        {faq.q}
                      </button>
                    </h2>
                    <div
                      id={`collapse${idx}`}
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-secondary small">
                        {faq.a}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 13 — REGISTRATION FORM */}
      <section id="register-section" className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                <div className="bg-dark text-white p-4 p-md-5 text-center">
                  <span className="badge bg-teal text-white mb-2" style={{ backgroundColor: '#0d9488' }}>இலவச பதிவு</span>
                  <h2 className="fw-bold mb-2">இன்றே Expert Partner ஆக தொடங்குங்கள்</h2>
                  <p className="text-light-50 mb-0">உங்கள் விவரங்களை பூர்த்தி செய்து சமர்ப்பியுங்கள். எங்கள் குழு சரிபார்த்து உங்களை தொடர்பு கொள்ளும்.</p>
                </div>

                <div className="card-body p-4 p-md-5 bg-white">
                  {isSubmitted ? (
                    <div className="alert alert-success p-4 rounded-3 text-center my-4">
                      <i className="bi bi-check-circle-fill text-success display-4 d-block mb-3"></i>
                      <h4 className="fw-bold">உங்கள் Registration Request பெறப்பட்டது!</h4>
                      <p className="mb-0">
                        எங்கள் team verification முடித்த பிறகு அடுத்த படி குறித்து உங்களை தொடர்புகொள்ளும். நன்றி!
                      </p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Full Name (முழு பெயர்) *</label>
                          <input
                            type="text"
                            name="fullName"
                            className="form-control"
                            required
                            placeholder="e.g. Ramesh Kumar"
                            value={formData.fullName}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Mobile Number *</label>
                          <input
                            type="tel"
                            name="mobileNumber"
                            className="form-control"
                            required
                            placeholder="10 digit mobile number"
                            value={formData.mobileNumber}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">WhatsApp Number</label>
                          <input
                            type="tel"
                            name="whatsappNumber"
                            className="form-control"
                            placeholder="WhatsApp Number"
                            value={formData.whatsappNumber}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">District (மாவட்டம்) *</label>
                          <select
                            name="district"
                            className="form-select"
                            required
                            value={formData.district}
                            onChange={handleInputChange}
                          >
                            <option value="">Select District</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Madurai">Madurai</option>
                            <option value="Tiruchirappalli">Tiruchirappalli</option>
                            <option value="Salem">Salem</option>
                            <option value="Tirunelveli">Tirunelveli</option>
                            <option value="Other">Other District</option>
                          </select>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Taluk / Location</label>
                          <input
                            type="text"
                            name="taluk"
                            className="form-control"
                            placeholder="e.g. Vadapalani"
                            value={formData.taluk}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">E-Sevai Centre Name</label>
                          <input
                            type="text"
                            name="centreName"
                            className="form-control"
                            placeholder="Your Centre Name"
                            value={formData.centreName}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Years of Experience</label>
                          <select
                            name="experience"
                            className="form-select"
                            value={formData.experience}
                            onChange={handleInputChange}
                          >
                            <option value="Less than 1 Year">Less than 1 Year</option>
                            <option value="1-3 Years">1-3 Years</option>
                            <option value="3-5 Years">3-5 Years</option>
                            <option value="5+ Years">5+ Years</option>
                          </select>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Expected Service Charge (Approx ₹)</label>
                          <input
                            type="text"
                            name="expectedCharge"
                            className="form-control"
                            placeholder="e.g. ₹50 - ₹150 per service"
                            value={formData.expectedCharge}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label font-semibold small d-block">Expert Service Categories</label>
                          <div className="row g-2">
                            {[
                              "Government Applications",
                              "Certificate Applications",
                              "Online Form Services",
                              "Document-related Services",
                              "Registration Services"
                            ].map((cat, idx) => (
                              <div key={idx} className="col-md-4">
                                <div className="form-check p-2 border rounded bg-light">
                                  <input
                                    className="form-check-input ms-1"
                                    type="checkbox"
                                    id={`cat-${idx}`}
                                    checked={formData.categories.includes(cat)}
                                    onChange={() => handleCategoryCheckbox(cat)}
                                  />
                                  <label className="form-check-label small ms-2" htmlFor={`cat-${idx}`}>
                                    {cat}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="col-12">
                          <label className="form-label font-semibold small">Specific Services You Can Handle / Want to Add</label>
                          <textarea
                            name="customServices"
                            className="form-control"
                            rows="2"
                            placeholder="உதாரணம்: Patta Transfer, Income Certificate, GST Registration..."
                            value={formData.customServices}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Daily Capacity</label>
                          <select
                            name="dailyCapacity"
                            className="form-select"
                            value={formData.dailyCapacity}
                            onChange={handleInputChange}
                          >
                            <option value="1-3 Applications">1-3 Applications</option>
                            <option value="3-5 Applications">3-5 Applications</option>
                            <option value="5-10 Applications">5-10 Applications</option>
                            <option value="10+ Applications">10+ Applications</option>
                          </select>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label font-semibold small">Payment Preference</label>
                          <select
                            name="paymentPref"
                            className="form-select"
                            value={formData.paymentPref}
                            onChange={handleInputChange}
                          >
                            <option value="UPI">UPI (Google Pay / PhonePe)</option>
                            <option value="Bank Transfer">Bank Account Transfer</option>
                            <option value="Both">Both</option>
                          </select>
                        </div>

                        <div className="col-12 mt-4">
                          <button
                            type="submit"
                            className="btn btn-primary-custom btn-lg w-100"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? (
                              <span><span className="spinner-border spinner-border-sm me-2"></span>Submitting...</span>
                            ) : (
                              <span>Expert Partner Registration <i className="bi bi-arrow-right ms-2"></i></span>
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 15 — FINAL CTA */}
      <section className="py-5 bg-dark text-white text-center">
        <div className="container">
          <div className="max-w-2xl mx-auto">
            <h2 className="fw-bold mb-3">உங்கள் Expertise-க்கு அடுத்த வாய்ப்பு இங்கிருந்து தொடங்கலாம்.</h2>
            <p className="text-light-50 mb-4">
              E-Sevai Pro Expert Partner ஆக இலவசமாக பதிவு செய்து, நீங்கள் நன்றாக அறிந்த சேவைகளை மற்ற மையங்களுடன் இணைந்து வழங்குங்கள்.
            </p>
            <button className="btn btn-primary-custom btn-lg px-4 mb-3" onClick={scrollToRegister}>
              இலவசமாக Expert Partner ஆக Register செய்யுங்கள்
            </button>
            <div className="small text-muted">
              Registration Fee இல்லை • Joining Fee இல்லை • Activation Fee இல்லை
            </div>
          </div>
        </div>
      </section>

      {/* STICKY MOBILE CTA BAR */}
      <div className="sticky-mobile-cta d-md-none">
        <button className="btn btn-primary-custom w-100 py-2" onClick={scrollToRegister}>
          Expert Partner Join - ₹0 Fee
        </button>
      </div>

      {/* ADMIN DASHBOARD MODAL WITH PASSWORD PROTECTED ACCESS */}
      {showAdminModal && (
        <div className="modal show d-block tab-index-1" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title fw-bold">
                  <i className="bi bi-shield-lock me-2 text-warning"></i>Admin Portal Access
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={handleCloseAdminModal}></button>
              </div>

              <div className="modal-body bg-light">
                {!isAdminAuthenticated ? (
                  /* LOGIN FORM FOR ADMIN */
                  <div className="row justify-content-center py-4">
                    <div className="col-md-6 col-lg-5">
                      <div className="card border-0 shadow-sm p-4">
                        <div className="text-center mb-3">
                          <i className="bi bi-person-lock display-4 text-teal" style={{ color: '#0d9488' }}></i>
                          <h5 className="fw-bold mt-2">Admin Login</h5>
                          <p className="small text-muted">பதிவுசெய்த விவரங்களைப் பார்க்க உங்கள் பாஸ்வேர்டை உள்ளிடவும்.</p>
                        </div>

                        {adminAuthError && (
                          <div className="alert alert-danger py-2 small text-center">{adminAuthError}</div>
                        )}

                        <form onSubmit={handleAdminLogin}>
                          <div className="mb-3">
                            <label className="form-label small fw-semibold">Admin Password</label>
                            <input
                              type="password"
                              className="form-control"
                              required
                              placeholder="Enter Admin Password"
                              value={adminPasswordInput}
                              onChange={(e) => setAdminPasswordInput(e.target.value)}
                            />
                          </div>
                          <button type="submit" className="btn btn-primary-custom w-100 py-2">
                            Unlock Dashboard
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                ) : (
                  /* PROTECTED ADMIN DASHBOARD DATA */
                  <>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 mb-4">
                      <div className="input-group">
                        <span className="input-group-text"><i className="bi bi-search"></i></span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Filter by name or district..."
                          value={adminFilter}
                          onChange={(e) => setAdminFilter(e.target.value)}
                        />
                      </div>
                      <span className="badge bg-secondary px-3 py-2">Total Leads in DB: {leadList.length}</span>
                    </div>

                    {isLoadingLeads ? (
                      <div className="text-center py-5">
                        <div className="spinner-border text-teal" role="status"></div>
                        <p className="mt-2 text-muted">Loading registrations from Database...</p>
                      </div>
                    ) : (
                      <div className="table-responsive bg-white rounded shadow-sm border">
                        <table className="table table-hover align-middle mb-0">
                          <thead className="table-dark">
                            <tr>
                              <th>Lead ID</th>
                              <th>Applicant</th>
                              <th>District / Centre</th>
                              <th>Experience</th>
                              <th>Categories</th>
                              <th>Status</th>
                              <th>Registered Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leadList.length === 0 ? (
                              <tr>
                                <td colSpan="7" className="text-center py-4 text-muted">
                                  இன்னும் எந்த பதிவுகளும் வரவில்லை (No registrations yet).
                                </td>
                              </tr>
                            ) : (
                              leadList
                                .filter((l) =>
                                  (l.full_name || '').toLowerCase().includes(adminFilter.toLowerCase()) ||
                                  (l.district || '').toLowerCase().includes(adminFilter.toLowerCase())
                                )
                                .map((lead) => (
                                  <tr key={lead.id}>
                                    <td className="fw-mono small">{lead.lead_id}</td>
                                    <td>
                                      <strong className="d-block">{lead.full_name}</strong>
                                      <small className="text-muted">{lead.mobile_number}</small>
                                    </td>
                                    <td>
                                      <div>{lead.district}</div>
                                      <small className="text-muted">{lead.centre_name}</small>
                                    </td>
                                    <td><span className="badge bg-light text-dark border">{lead.experience}</span></td>
                                    <td className="small">{lead.categories}</td>
                                    <td>
                                      <span className={`badge ${
                                        lead.status === 'Approved' ? 'bg-success' :
                                        lead.status === 'Under Review' ? 'bg-warning text-dark' :
                                        lead.status === 'Rejected' ? 'bg-danger' : 'bg-primary'
                                      }`}>
                                        {lead.status}
                                      </span>
                                    </td>
                                    <td className="small text-muted">{lead.created_at}</td>
                                  </tr>
                                ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}
              </div>

              <div className="modal-footer bg-white">
                <button className="btn btn-secondary btn-sm" onClick={handleCloseAdminModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer className="py-4 bg-black text-secondary border-top border-secondary text-center small mb-5 mb-md-0">
        <div className="container">
          <p className="mb-1">© 2026 E-Sevai Pro. All rights reserved.</p>
          <p className="mb-0 text-muted">A modern platform for E-Sevai service operators & experts.</p>
        </div>
      </footer>

    </div>
  );
}